import React from 'react';
import { useAuth } from '../../hooks/useAuth';

// AuthProvider owns SDK initialization and sessionKey exchange.
const AuthGuard = ({ children }) => {
  const { isLogin, loading } = useAuth();
  if (isLogin) return <>{children}</>;
  return loading ? (
    <div className="flex justify-center items-center py-3 h-full">Loading ...</div>
  ) : null;
};

export default AuthGuard;
